<div class="splash-container" id="div_splash-container_2062c057">
  <div
    class="splash-container-images"
    id="div_splash-container-images_51b94e59"
  >
    <div class="row justify-content-center" id="div_row_d9378c75">
      <div class="top-img" id="div_top-img_e18c67d5">
        <div class="col" id="div_col_8ca960fc"></div>
        <div class="col-12 text-center" id="div_col-12_a3a157f9">
          <h1 class="card-title" id="h1_card-title_2520adcd">FAQs</h1>
        </div>
        <div class="col" id="div_col_936b9ef6"></div>
      </div>
    </div>
    <div class="main-container" id="div_main-container_ec81ad98">
      <div
        class="splash-bottom-container"
        id="div_splash-bottom-container_a7f8eb0d"
      >
        <div
          class="businedd-delivery-panel"
          id="div_businedd-delivery-panel_470a8481"
        >
          <div
            class="p-grid p-justify-center custom-card-container"
            id="div_p-grid_b9be74c4"
          >
            <div class="container" id="div_container_396dbfb3">
              <div class="row justify-content-center" id="div_row_76c5c5af">
                <div
                  class="col-12 col-md-8 custom-card"
                  id="div_col-12_8008d998"
                >
                  <div class="row" id="div_row_958a7de7">
                    <div class="col" id="div_col_18e117d7"></div>
                    <div class="col-12" id="div_col-12_e7c0ced7">
                      <div class="card" id="div_card_43beee9e">
                        <div class="card-body" id="div_card-body_898a2f36">
                          <div class="accordion" id="accordionFAQ">
                            <div
                              class="accordion-item"
                              id="div_accordion-item_29326995"
                            >
                              <h2 class="accordion-header" id="headingOne">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                  id="button_accordion-button_f093fe03"
                                >
                                  What is Railcar Search?
                                </button>
                              </h2>
                              <div
                                id="collapseOne"
                                class="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_17714a66"
                                >
                                  Railcar Search is an online platform that
                                  simplifies railcar procurement by offering
                                  options to customize and request quotes for
                                  leased railcars.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_29219b87"
                            >
                              <h2 class="accordion-header" id="headingTwo">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="collapseTwo"
                                  id="button_accordion-button_a750fc31"
                                >
                                  How does Railcar Search work?
                                </button>
                              </h2>
                              <div
                                id="collapseTwo"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_c6d2390d"
                                >
                                  Railcar Search utilizes a recommendation
                                  engine to match what you are transporting with
                                  suitable railcars and establishes direct
                                  communication with sales representatives for
                                  efficient transactions.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_c3ce18dc"
                            >
                              <h2 class="accordion-header" id="headingThree">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseThree"
                                  aria-expanded="false"
                                  aria-controls="collapseThree"
                                  id="button_accordion-button_16674f3d"
                                >
                                  Why should I use Railcar Search?
                                </button>
                              </h2>
                              <div
                                id="collapseThree"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_69b788bf"
                                >
                                  Railcar Search offers personalized
                                  recommendations based on our extensive data
                                  and enables direct communication with sales
                                  representatives for effective decision-making.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_e6de1460"
                            >
                              <h2 class="accordion-header" id="headingFour">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                  aria-expanded="false"
                                  aria-controls="collapseFour"
                                  id="button_accordion-button_d99a3ac5"
                                >
                                  Will there be more features in the future in
                                  Railcar Search?
                                </button>
                              </h2>
                              <div
                                id="collapseFour"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingFour"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_009cba62"
                                >
                                  Yes, plans are underway to include additional
                                  railcar types, new builds, and other options
                                  to expand our offerings at Railcar Search.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_ddf1b1db"
                            >
                              <h2 class="accordion-header" id="headingFive">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFive"
                                  aria-expanded="false"
                                  aria-controls="collapseFive"
                                  id="button_accordion-button_ee4d5e43"
                                >
                                  How can I estimate shipping costs at Railcar
                                  Search?
                                </button>
                              </h2>
                              <div
                                id="collapseFive"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingFive"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_2265c371"
                                >
                                  While not currently available on the platform,
                                  you can contact your sales representative to
                                  discuss freight cost estimates.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_17bfb9d2"
                            >
                              <h2 class="accordion-header" id="headingSix">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseSix"
                                  aria-expanded="false"
                                  aria-controls="collapseSix"
                                  id="button_accordion-button_15f5dcef"
                                >
                                  What feedback have users given about Railcar
                                  Search?
                                </button>
                              </h2>
                              <div
                                id="collapseSix"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingSix"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_803391e4"
                                >
                                  Users appreciate Railcar Search’s
                                  user-friendly interface, custom
                                  recommendations, and efficient communication
                                  channels.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_c9062fb0"
                            >
                              <h2 class="accordion-header" id="headingSeven">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseSeven"
                                  aria-expanded="false"
                                  aria-controls="collapseSeven"
                                  id="button_accordion-button_3f439b46"
                                >
                                  How is pricing determined in Railcar Search?
                                </button>
                              </h2>
                              <div
                                id="collapseSeven"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingSeven"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_ccd87a03"
                                >
                                  The displayed prices on Railcar Search are for
                                  as-is railcars under a standard lease term;
                                  final quotes may vary depending on the
                                  preferences selected within the platform when
                                  submitting a quote request.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_d1120d9c"
                            >
                              <h2 class="accordion-header" id="headingEight">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseEight"
                                  aria-expanded="false"
                                  aria-controls="collapseEight"
                                  id="button_accordion-button_b2523569"
                                >
                                  How often is availability updated at Railcar
                                  Search?
                                </button>
                              </h2>
                              <div
                                id="collapseEight"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingEight"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_47fe18f7"
                                >
                                  Availability of railcars within Railcar Search
                                  is updated daily, ensuring current information
                                  about inventory status.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_c0ec25aa"
                            >
                              <h2 class="accordion-header" id="headingNine">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseNine"
                                  aria-expanded="false"
                                  aria-controls="collapseNine"
                                  id="button_accordion-button_a15e6583"
                                >
                                  Where can I find my search history in Railcar
                                  Search?
                                </button>
                              </h2>
                              <div
                                id="collapseNine"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingNine"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_981fad5b"
                                >
                                  Your previous searches can be located by
                                  visiting your profile on Railcar Search and
                                  choosing 'Account History' from the sidebar
                                  menu.
                                </div>
                              </div>
                            </div>
                            <div
                              class="accordion-item"
                              id="div_accordion-item_f3c62712"
                            >
                              <h2 class="accordion-header" id="headingTen">
                                <button
                                  class="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseTen"
                                  aria-expanded="false"
                                  aria-controls="collapseTen"
                                  id="button_accordion-button_93430c79"
                                >
                                  How do I manage my saved SDS documents in
                                  Railcar Search?
                                </button>
                              </h2>
                              <div
                                id="collapseTen"
                                class="accordion-collapse collapse"
                                aria-labelledby="headingTen"
                                data-bs-parent="#accordionFAQ"
                              >
                                <div
                                  class="accordion-body"
                                  id="div_accordion-body_458c2fb0"
                                >
                                  Saved SDS documents within Railcar Search can
                                  be managed by selecting 'SDS Repository' from
                                  the sidebar menu after accessing your profile.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row button-container"
                            id="div_row_c3853232"
                          >
                            <div class="col mt-2 help" id="div_col_80fb53e1">
                              Need more help?
                            </div>
                            <div class="col" id="div_col_6fa488e2">
                              <div
                                class="d-grid gap-2 d-md-flex justify-content-md-end"
                                id="div_d-grid_c7f0a80e"
                              >
                                <button
                                  class="btn btn-light button-small"
                                  type="button"
                                  onclick="window.open('https://www.trinityrail.com/contact/', '_blank');"
                                  id="button_btn_7636f83b"
                                >
                                  contact us
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col" id="div_col_edc6fae4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
